import { combineReducers } from 'redux';
import app from './app';
import configurator from './configurator';
import colorPicker from './colorPicker';
import textEditor from './textEditor';
import transformArea from './transformArea';
import overview from './overview';
import introductionLayer from './introductionLayer';
import staticPen from './staticPen';
import checkout from './checkout';

const rootReducer = combineReducers({
    app,
    configurator,
    colorPicker,
    textEditor,
    transformArea,
    overview,
    introductionLayer,
    staticPen,
    checkout,
});

export default rootReducer;
